module.exports = __webpack_public_path__ + "static/media/image-success.e82256b0.png";